import axios from 'axios'
import urls from '../../util/urls'

const state = {
  listaDeContasPagarDoDia: []
}

const mutations = {
  atualizarListaContasPagarDoDia(state, payload) {
    state.listaDeContasPagarDoDia = payload;
  },

  limparContasPagar(state) {
    state.listaDeContasPagarDoDia = []
  }
}

const actions = {
  recuperarContasPagarDoDia(context) {
    return axios.get(urls.DASHBOARD_RECUPERAR_CONTAS_PAGAR_DO_DIA)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarContasPagarDoDia');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return context.commit('atualizarListaContasPagarDoDia', response.data.lista);
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}